import { useEffect } from "react";
import ENV from "../../constants/Environment";

const ZENDESK_SCRIPT_ID = "ze-snippet";
const ZENDESK_SCRIPT_URL =
  "https://static.zdassets.com/ekr/snippet.js?key=7bbd7dc2-b204-49ed-8409-ce897c2b58d8";

let zendeskLoadPromise;

const loadZendesk = () => {
  if (window.zE) {
    return Promise.resolve(window.zE);
  }

  if (zendeskLoadPromise) {
    return zendeskLoadPromise;
  }

  zendeskLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(ZENDESK_SCRIPT_ID);
    const script = existingScript || document.createElement("script");

    const handleLoad = () => resolve(window.zE);
    const handleError = () => {
      zendeskLoadPromise = undefined;
      reject(new Error("Unable to load Zendesk Messenger"));
    };

    script.addEventListener("load", handleLoad, { once: true });
    script.addEventListener("error", handleError, { once: true });

    if (!existingScript) {
      script.async = true;
      script.id = ZENDESK_SCRIPT_ID;
      script.src = ZENDESK_SCRIPT_URL;
      document.body.appendChild(script);
    }
  });

  return zendeskLoadPromise;
};

export const useZendesk = (userId) => {
  useEffect(() => {
    if (!userId) {
      return;
    }

    let cancelled = false;
    const abortController = new AbortController();

    const loginUser = (zendesk) => {
      zendesk("messenger", "loginUser", (callback) => {
        fetch(`${ENV.onwardApiUrl}/api/custodians/${userId}/zendesk/tokens`, {
          method: "POST",
          signal: abortController.signal,
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Zendesk token request failed: ${response.status}`
              );
            }
            return response.text();
          })
          .then((token) => {
            if (!cancelled) {
              callback(token);
              zendesk("messenger:set", "cookies", true);
            }
          })
          .catch((error) => {
            if (error.name !== "AbortError") {
              console.error(error);
            }
          });
      });
    };

    loadZendesk()
      .then((zendesk) => {
        if (!cancelled && zendesk) {
          zendesk("messenger", "show");
          loginUser(zendesk);
        }
      })
      .catch((error) => {
        if (!cancelled) {
          console.error(error);
        }
      });

    return () => {
      cancelled = true;
      abortController.abort();

      if (window.zE) {
        window.zE("messenger:set", "cookies", false);
      }
    };
  }, [userId]);
};
